var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoc = function SvgDoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "20px",
    width: "20px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "office-file-doc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77995",
    "data-name": "Path 77995",
    d: "M4.5,18.667A2.667,2.667,0,0,0,7.167,16V14.667A2.667,2.667,0,0,0,4.5,12Z",
    transform: "translate(-0.417 -1.25)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77996",
    "data-name": "Path 77996",
    d: "M11.833,12A1.333,1.333,0,0,0,10.5,13.333v4a1.333,1.333,0,1,0,2.667,0v-4A1.333,1.333,0,0,0,11.833,12Z",
    transform: "translate(-1.083 -1.25)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77997",
    "data-name": "Path 77997",
    d: "M19.167,12A2.667,2.667,0,0,0,16.5,14.667V16a2.667,2.667,0,0,0,2.667,2.667",
    transform: "translate(-1.75 -1.25)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77998",
    "data-name": "Path 77998",
    d: "M20.359,5.024a1.333,1.333,0,0,1,.39.942V18.75a2,2,0,0,1-2,2h-16a2,2,0,0,1-2-2v-16a2,2,0,0,1,2-2H15.53a1.333,1.333,0,0,1,.943.39Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77999",
    "data-name": "Path 77999",
    d: "M17.249.748v4a1.333,1.333,0,0,0,1.333,1.333h4",
    transform: "translate(-1.833 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc.d8207c9e.svg";
export { ForwardRef as ReactComponent };